import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgoOrDate'
})
export class TimeAgoOrDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    const date = new Date(value);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);

    if (diffHours < 1) {
      return diffMinutes <= 1 ? 'just now' : `${diffMinutes} minutes ago`;
    }

    if (diffHours < 24) {
      return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`;
    }

    // Format: Jun 27, 2025, 2:45 PM
    return date.toLocaleString('en-US', {
      dateStyle: 'medium',
    });
  }
}
